// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme-dark .sub-mobile-menu{background:#303030;color:hsla(0,0%,100%,.85)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
